import React, { useState } from 'react';

function FrameExtractor() {
  const [videoFile, setVideoFile] = useState(null);
  const [extractedFrame, setExtractedFrame] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);
  const [videoInfo, setVideoInfo] = useState(null);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('video/')) {
        setError('Per favore carica un file video valido');
        return;
      }
      setVideoFile(file);
      setError(null);
      setExtractedFrame(null);
      setVideoInfo(null);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (file.type.startsWith('video/')) {
        setVideoFile(file);
        setError(null);
        setExtractedFrame(null);
        setVideoInfo(null);
      } else {
        setError('Per favore carica solo file video (MP4, MOV, AVI, ecc.)');
      }
    }
  };

  const extractFrame = async () => {
    if (!videoFile) {
      setError('Seleziona un video prima');
      return;
    }

    setProcessing(true);
    setError(null);

    try {
      const formData = new FormData();
      formData.append('file', videoFile);

      // Determina l'URL del backend
      const backendUrl = window.location.port === '3000'
        ? 'http://localhost:8000'  // Sviluppo locale
        : window.location.origin;   // Produzione

      const response = await fetch(`${backendUrl}/api/extract-last-frame`, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Errore durante l\'estrazione del frame');
      }

      const data = await response.json();

      setExtractedFrame(data.frame);
      setVideoInfo({
        duration: data.duration,
        extractedAt: data.extracted_at
      });

    } catch (err) {
      console.error('Errore:', err);
      setError(err.message);
    } finally {
      setProcessing(false);
    }
  };

  const downloadFrame = () => {
    if (!extractedFrame) return;

    const link = document.createElement('a');
    link.href = extractedFrame;
    link.download = `last_frame_${videoFile.name.split('.')[0]}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const resetTool = () => {
    setVideoFile(null);
    setExtractedFrame(null);
    setError(null);
    setVideoInfo(null);
    setProcessing(false);
  };

  return (
    <div className="frame-extractor-container">
      <div className="frame-extractor-content">
        <h2>🎬 Estrattore Ultimo Frame</h2>
        <p className="subtitle">Carica un video ed estrai l'ultimo frame come immagine PNG</p>

        {/* Upload Area */}
        {!extractedFrame && (
          <div className="upload-section">
            <div
              className={`upload-area ${videoFile ? 'has-file' : ''}`}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              onClick={() => document.getElementById('videoInput').click()}
            >
              {videoFile ? (
                <div className="uploaded-file">
                  <span className="file-icon">🎥</span>
                  <div className="file-info">
                    <strong>{videoFile.name}</strong>
                    <small>{(videoFile.size / (1024 * 1024)).toFixed(2)} MB</small>
                  </div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      resetTool();
                    }}
                    className="btn-remove"
                  >
                    ✕
                  </button>
                </div>
              ) : (
                <div className="upload-prompt">
                  <span className="upload-icon">📁</span>
                  <p>Clicca o trascina il video qui</p>
                  <small>Supporta MP4, MOV, AVI e altri formati video</small>
                </div>
              )}
            </div>
            <input
              id="videoInput"
              type="file"
              accept="video/*"
              onChange={handleFileSelect}
              style={{ display: 'none' }}
            />

            {videoFile && (
              <button
                onClick={extractFrame}
                disabled={processing}
                className="btn-primary btn-large"
              >
                {processing ? '⏳ Estrazione in corso...' : '🎯 Estrai Ultimo Frame'}
              </button>
            )}
          </div>
        )}

        {/* Error Message */}
        {error && (
          <div className="error-message">
            ❌ {error}
          </div>
        )}

        {/* Result */}
        {extractedFrame && (
          <div className="result-section">
            <h3>✅ Frame Estratto con Successo!</h3>

            {videoInfo && (
              <div className="video-info-box">
                <div className="info-row">
                  <span>Durata video:</span>
                  <strong>{videoInfo.duration.toFixed(2)}s</strong>
                </div>
                <div className="info-row">
                  <span>Frame estratto a:</span>
                  <strong>{videoInfo.extractedAt.toFixed(2)}s</strong>
                </div>
                <div className="info-row">
                  <span>File originale:</span>
                  <strong>{videoFile.name}</strong>
                </div>
              </div>
            )}

            <div className="frame-preview">
              <img src={extractedFrame} alt="Ultimo frame estratto" />
            </div>

            <div className="result-actions">
              <button
                onClick={downloadFrame}
                className="btn-primary"
              >
                📥 Scarica Frame PNG
              </button>
              <button
                onClick={resetTool}
                className="btn-secondary"
              >
                🔄 Estrai Altro Frame
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default FrameExtractor;
